(() => {
  const gallerySwiper = new Swiper(".js-product-media-gallery", {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
  });

  const openBtn = document.querySelector(".js-product-media-gallery__more-pics");
  const closeBtn = document.querySelector(".js-product-media-gallery__modal--close");
  const modal = document.querySelector(".js-product-media-gallery__modal");

  const productVariantsParent = document.querySelector(".js-product-variants-parent");
  const firstMobileImage = document.querySelector(".js-media-gallery-mobile-slide1 img");

  function switchImage(newImage) {
    if (firstMobileImage) {
      firstMobileImage.src = newImage.src;
      firstMobileImage.srcset = newImage.src;
      gallerySwiper.slideToLoop(0, 200, false);
    }
  }

  function handleVariantSwitch(e) {
    const checkedInput = e.target;
    if (checkedInput.checked) {
      const scriptElement = document.querySelector(
        `script[type="application/json"][data-resource="${checkedInput.id}"]`
      );
      if (scriptElement) {
        const jsonContent = scriptElement.textContent;
        const parsedData = JSON.parse(jsonContent);
        if (parsedData) {
          const { featured_image } = parsedData;
          if (featured_image) {
            switchImage(featured_image);
          }
        }
      }
    }
  }

  if (productVariantsParent) {
    productVariantsParent.addEventListener("change", (event) => {
      handleVariantSwitch(event);
    });
  }

  openBtn.addEventListener("click", (e) => {
    modal.showModal();
  });

  closeBtn.addEventListener("click", (e) => {
    modal.close();
  });

  modal.addEventListener("click", (e) => {
    const dialogDimensions = modal.getBoundingClientRect();
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      modal.close();
    }
  });
})();
